import {Component, OnInit} from '@angular/core';
import {EnvService} from "../services/env.service";
import {HttpClient} from "@angular/common/http";
import { ActivatedRoute, Router, Params } from '@angular/router';
import {AlertService} from "../services/alert.service";

@Component({
  selector: 'micro-smsType-detail',
  templateUrl: './smsType-detail.component.html'
})
export class SmsTypeDetailComponent implements OnInit {
  smsType:any;

  constructor(protected env: EnvService,
              protected http: HttpClient,
              private route: ActivatedRoute,
              private router:Router,
              private alertService:AlertService) {
  }

  ngOnInit(): void {
    this.route.params
      .subscribe((params: Params) => {
        let id:any = params['id'];
        if (id === '0') {
          this.createNew();
        } else {
          this.http.get(`${this.env.e.url}/sms/smsTypes/${id}`).subscribe(
            data => {
              this.smsType = data as any;
            }
          );
        }
      });
  }

  createNew() {
    this.smsType = {};
  }

  save() {
    if (!this.smsType.id) {
      this.http.post(`${this.env.e.url}/sms/smsTypes`, this.smsType)
        .subscribe(
          data => {
            this.smsType = data;
            this.alertService.info(`Created SMS Type ${this.smsType.value}`);
          }
        );
    } else {
      this.http.put(`${this.env.e.url}/sms/smsTypes/${this.smsType.id}`, this.smsType)
        .subscribe(
          data => {
            this.smsType = data;
            this.alertService.info(`Updated SMS Type`);
          }
        );
    }
  }

  delete() {
    this.http.delete(`${this.env.e.url}/sms/smsTypes/${this.smsType.id}`)
      .subscribe(
        complete => {
          this.alertService.info(`Deleted SMS Type ${this.smsType.value}`);
          this.router.navigate(["/sms/smsTypes"]);
        }
      );
  }
}
